import * as React from 'react';
import { Container } from '../components';

const ColorsField = ({ record }) =>
	record && record.colors ? (
		<Container source="colors">{record.colors.join(', ')}</Container>
	) : null;

export default ColorsField;
